<template>
  <div class="commodityDetails">
        <!-- 轮播图 -->
        <div class="goodsDisplay">
            <div class="returnContent" @click="goBackPage($router)">
                <i class="iconfont icon-fanhui"></i>
            </div>
            <van-swipe class="my-swipe" :autoplay="3000" @change="onChange">
                <van-swipe-item v-for="(itemThumb,index) in allIndex" :key="index">
                <img class="thumbImg" v-lazy="itemThumb" />
                </van-swipe-item>
                <!-- 自定义轮播索引 -->
                <template #indicator> 
                    <div class="custom-indicator">
                        {{ current + 1 }}/{{allIndex.length}}
                    </div>
                </template>
            </van-swipe>
        </div>
        <div v-if="detailData">
            <!-- 标题 -->
            <div class="brandContent">
                <p class="brandParice">
                    {{shopOrintegral=="shop"?'￥'+detailData.price:detailData.integral+' 积分'}}
                    <!-- ￥{{detailData.realPrice}} -->
                </p>
                <p class="brandTitleBlod">
                    {{detailData.subTitle}}
                </p>
                <p v-if="detailData.productBrandEntity" class="smallBrand">
                    品牌：{{detailData.productBrandEntity.brandName}}
                </p>
            </div>
            <!-- 规格 -->
            <div  class="specificationsBox" v-if="specifications.length">
                <div class="scrollBox">
                    <div class="specificationsTitle">
                        规格
                    </div>
                    <div v-for="(item,index) in specifications" :key="index" class="specifications">
                        <p style="font-weight: bold;">{{item.name}}</p>
                        <p>{{item.data}}</p>
                    </div>
                </div>
            </div>
            <div class="babyDetail">
                <div class="detialText">宝贝详情</div>
            </div>
            <!-- 详情 -->
            <div class="detailHtml">
                <div v-html="detailData.detail"></div>
            </div>
            
            <!-- 立即兑换 -->
            <div class="redeemnow">
                <div class="moniButton" >
                    <!-- <div class="intocar" @click="addtocar">
                        加入购物车
                    </div> -->
                    <div class="buy" @click="redeemnowGoods">
                        {{shopOrintegral=="shop"?"立即购买":"立即兑换"}}
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Lazyload } from 'vant';
Vue.use(Lazyload);
export default {
    data() {
        return {
            detailData:null, //商品详情
            allIndex:[] ,//轮播图
            specifications:null ,//规格
            current:0, //轮播图当前位置
        };
    },
    created() {
        this.datailData();
    },
    methods: {
        // 加入购物车
        addtocar(){
            if(window.localStorage.civilizationId){ //调接口
                // this.detailData.productId //商品id
            }else{
                this.login(); //没有用户id 跳到登入
            }
        },
        // 立即购买或则立即兑换接口
        redeemnowGoods(){
            if(window.localStorage.civilizationId){ //跳转页面
                this.Event.$emit("refresh",""); //刷新接口
                this.$router.push({
                    path:"/purchasePage",
                    query:{ //商品id
                        id:this.detailData.productId
                    }
                })
            }else{
                this.login(); //没有用户id 跳到登入
            }
        },
        // 获取详情接口
        datailData(){
            this.$http.get(
                this.javalinkTwo +"mmall/product/getProductInfoToAPPHtml?productId="+this.$route.query.id
            )
            .then(res => {
                // console.log(res.data);
                if (res.data.success) {
                    // this.webviewOload(res.data.data.detail);
                    this.detailData = res.data.data;
                    this.detailData.detail=this.detailData.detail.replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&quot;/g,"'").replace(/&nbsp;/g," ");
                    this.allIndex = JSON.parse(this.detailData.subImages); //轮播图
                    this.specifications=[]; //清空
                    // 规格
                    if(this.detailData.weight){
                        this.specifications=[{
                            name:"重量",
                            data:this.detailData.weight
                        }]
                    }
                    for(var i=0;i<this.detailData.productParamGroupDTOList.length;i++){
                        if(this.detailData.productParamGroupDTOList[i].in.length>0){
                            var perCon={
                                name:this.detailData.productParamGroupDTOList[i].paramName,
                                data:this.detailData.productParamGroupDTOList[i].in.join(",")
                            }
                            this.specifications.push(perCon); //所有规格
                        }
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        // 轮播图切换
        onChange(index){
            //自定义索引
            this.current = index;
        }
    }
};
</script>
<style>
    .detailHtml *{
        max-width: 100%!important;
    }
</style>
<style scoped>
.commodityDetails {
  width: 100%;
  height: 100%;
  background-color: #F1F1F1;
  overflow: auto;
  padding-bottom: 60px;
  box-sizing: border-box;
}

/* 轮播图 */
.goodsDisplay{
    width: 100%;
    padding-bottom: 100%;
    position: relative;
    background: #fff;
}
.returnContent{
    width: 35px;
    height: 35px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    position: absolute;
    top: 35px;
    left: 20px;
    z-index: 99;
    background: rgba(0,0,0,0.5);
}
.returnContent .iconfont{
    font-size: 20px;
}
.my-swipe{
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
}
.thumbImg{
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.custom-indicator {
  position: absolute;
  right: 5px;
  bottom: 5px;
  padding: 2px 5px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
  color: #fff;
}



.modelalert{
    background: #FFFFFF;
}
.redeemnow{
    position: fixed;
    bottom: 0px;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #FFFFFF;
    border-top: 1px solid #DDDDDD;
    padding: 0px 20px;
    box-sizing: border-box; 
    z-index: 1000;
}
.moniButton{
    width: 60%;
    height: 40px;
    text-align: center;
    color: #FFFFFF;
    background-color: #ff5100;
    font-size: 15px;
    line-height: 40px;
    border-radius: 100px;
    overflow: hidden;
    display: flex;
}
.moniButton .intocar{
    background-color: orange;
    text-align: center;
    width: 50%;
}
.moniButton .buy{
    width: 100%;
    color: #fff;
}
.GoodsDetail{
    background-color: #F1F1F1;
    position: relative;
    padding-bottom: 50px;
}
.brandContent{
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 20px;
    box-sizing: border-box;
    background-color: #FFFFFF;
}
.specificationsBox{
    white-space: nowrap;
    margin-top: 10px;
    background-color: #FFFFFF;
    width: 100%;
    box-sizing: border-box;
    overflow: auto;
}
.scrollBox{
    height: 80px;
    display: flex;
    align-items: center;
}
.specificationsTitle{
    height:40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: bold;
    display: inline-block;
    margin: 0px;
    padding: 0px 15px;
}
.specifications{
    height: 40px;
    display: inline-block;
    text-align: center;
    padding: 0px 15px;
    text-align: center;
    line-height: 20px;
    font-size: 14px;
}
.brandParice{
    color: #FE4D43;
    font-size: 20px;
}
.brandTitleBlod{
    margin-top: 10px;
    font-weight: bold;
    font-size: 15px;
}
.smallBrand{
    color: #999999;
    font-size: 12px;
    margin-top: 10px;
}
.detailHtml{
    width: 100%;
    margin-top: 10px;
    background-color: #FFFFFF;
    padding-top:20px;
    overflow: hidden;
    padding-bottom: 20px;
    font-size: 16px;
}
.babyDetail{
    width: 100%;
    color: #666666;
    font-size: 12px;
    height: 30px;
    text-align: center;
    margin-top: 10px;
    position: relative;
}
.detialText{
    position: absolute;
    top: 7px;
    width: 58px;
    left: 50%;
    margin-left: -29px;
    z-index: 999;
    background-color: #F1F1F1;
}
.babyDetail::after{
    content: "";
    display: block;
    width: 200px;
    height: 1px;
    background-color: #DDDDDD;
    position: absolute;
    top: 14.5px;
    left: 50%;
    margin-left: -100px;
}


</style>